import servicesUtils from "../../../utils/servicesUtils";
import { useQuery } from "react-query";
var useGetMeeting = function useGetMeeting(id) {
  return useQuery(["meeting", id], function () {
    return servicesUtils.getService("/recordings/".concat(id));
  }, {
    enabled: !!id
  });
};
export default useGetMeeting;